import * as React from 'react';
import * as styled from './styled';
import Dropdown from 'components/Dropdown';
import {ActionSheetProps} from './types';

/**
 *
 * @param {ActionSheetProps} props
 * @return {React.ReactElement<ActionSheetProps>}
 * @constructor
 */
export default function ActionSheet(
  {
    title,
    children,
    actions,
    ...otherProps
  }: ActionSheetProps,
): React.ReactElement<ActionSheetProps> {
  /**
   * Render header.
   * @return {JSX.Element}
   */
  function renderHeader(): JSX.Element {
    return (
      <styled.Header>
        <styled.Title>
          {title}
        </styled.Title>
      </styled.Header>
    );
  }

  /**
   * Render content.
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    return (
      <styled.Content>
        {children}
      </styled.Content>
    );
  }

  /**
   * Render footer.
   * @return {JSX.Element}
   */
  function renderFooter(): JSX.Element {
    return (
      <styled.Footer>
        {actions?.map((action, index) => (
          <styled.Button key={index} actionType={action.type}>
            {action.children}
          </styled.Button>
        ))}
      </styled.Footer>
    );
  }

  return (
    <Dropdown gap={6} {...otherProps}>
      <styled.Wrapper>
        {renderHeader()}
        {renderContent()}
        {renderFooter()}
      </styled.Wrapper>
    </Dropdown>
  );
}
